import '../css/index.css'
import '../css/coffee.css'
import coffeeIcon from '../assets/coffee-dark.svg';

const Coffee = ({isDark}) => {
   

    return (
     
        <a href="https://www.buymeacoffee.com/vicver"  target="_blank"  title='@vicver' rel='noreferrer' className='coffeeButton'> 
                <div className="coffeeContent">
                    <div className="coffeeIcon" style={{ '--icon-url': `url(${coffeeIcon})` }}/>
                    Buy me a Coffee 
                </div>
        </a>
        
    );                  
}
 
export default Coffee;